module.exports = __webpack_public_path__ + "img/success-ring.71a7eb66.svg";